module.exports = __webpack_public_path__ + "img/logo.3c988e93.png";